import type { AttributeReviewValueFixInput } from "@/graphql/generated";
import type { PoolValue } from "@/lib/attributeReview/valueView";
import { StepNote } from "../ReviewDrawer/StepNote";
import { ValueMapTable } from "../ReviewDrawer/ValueMapTable";
import { TextFieldPool, type TextPoolProps } from "./TextFieldPool";

export type Pool = {
  key: string;
  description?: string | null;
  source: string;
  check?: string | null;
  restriction_mode?: string | null;
  values?: { key: string; label: string }[];
};

type Props = {
  canTakePool: boolean;
  pool: Pool | null;
  values: PoolValue[];
  fixes: Record<string, AttributeReviewValueFixInput>;
  setFix: (fix: AttributeReviewValueFixInput) => void;
  undoFix: (storeValue: string) => void;
  readOnly?: boolean;
  text?: TextPoolProps | null;
  storeName: string;
};

export function PoolSection({
  canTakePool,
  pool,
  values,
  fixes,
  setFix,
  undoFix,
  readOnly = false,
  text = null,
  storeName,
}: Props) {
  if (!canTakePool && !pool && values.length === 0) return null;
  if (text) return <TextFieldPool pool={pool} readOnly={readOnly} {...text} />;
  return (
    <>
      {!readOnly && pool?.check === "please check" && (
        <StepNote
          tone="warn"
          title="The AI was not sure this list fits."
          body="Check each value below."
        />
      )}
      <ValueMapTable
        values={values}
        poolValues={pool?.values ?? []}
        fixes={fixes}
        setFix={setFix}
        undoFix={undoFix}
        readOnly={readOnly}
        storeName={storeName}
      />
    </>
  );
}
